var headerMenu = (() => {
  var setViewAllButtons = () => {
    document.querySelectorAll('[js-mobile-menu-view-all]').forEach(element => {
      element.addEventListener('click', (e) => {
        e.preventDefault();
        const container = element.closest('.menu-drawer__inner-submenu');
        if (!container) return;
        const backButton = container.querySelector('.menu-drawer__close-button');
        if (backButton) backButton.click();
      });
    });
  }
  var initialize = () => {
    setViewAllButtons();
  }
  return {
    init: initialize
  }
})();

var cartItemImageModal = (() => {
  var showModal = (modal) => {
    modal.classList.add('active');
    modal.style.visibility = 'visible';
  }
  var hideModal = (modal) => {
    if (!modal) return;
    modal.classList.remove('active');
    setTimeout(() => {
      modal.style.visibility = 'hidden';
    }, 200);
  }
  var initialize = () => {
    document.querySelectorAll('[js-cart-item-image-modal] [js-close]').forEach(element => {
      // A cart refresh now hands the media cells that are already painted over to the new
      // markup, so the element reaching this loop may already be carrying its listener.
      if (element.dataset.closeBound) return;
      element.dataset.closeBound = 'true';
      element.addEventListener('click', () => {
        hideModal(element.closest('[js-cart-item-image-modal]'));
      });
    });
  }
  return {
    init: initialize,
    show: showModal
  }
})();

var cartItem = (() => {
  var showCartItemImageModal = (cartItemImage) => {
    if (!cartItemImage.closest('td')) return;
    const cartItemImageModalElement = cartItemImage.closest('td').querySelector('[js-cart-item-image-modal]');
    if (!cartItemImageModalElement) return;

    // The zoom image is only requested once somebody opens it, from the URL the thumbnail
    // already shows (snippets/cart-tib-image.liquid), so it normally comes out of the cache.
    const zoomImage = cartItemImageModalElement.querySelector('img[data-src]');
    if (zoomImage) {
      const zoomSrc = cartItemImage.currentImageSrc || zoomImage.dataset.src;
      if (zoomImage.getAttribute('src') !== zoomSrc) zoomImage.src = zoomSrc;
    }
    cartItemImageModal.show(cartItemImageModalElement);
  }
  var initialize = () => {
    if (!document.querySelector('body').classList.contains('cart-drawer-ab-test')) {
      return;
    }

    cartItemImageModal.init();
    var cartItemImages = document.querySelectorAll('reloaded-tib-image');
    cartItemImages.forEach(cartItemImage => {
      if (cartItemImage.dataset.modalBound) return;
      cartItemImage.dataset.modalBound = 'true';
      cartItemImage.addEventListener('click', () => {
        showCartItemImageModal(cartItemImage);
      });
    });
  }
  return {
    init: initialize
  }
})();

var app = (() => {
  var initialize = () => {
    headerMenu.init();
    cartItem.init();
  }
  return {
    init: initialize
  }
})();

document.addEventListener('DOMContentLoaded', () => {
  app.init();
});

document.addEventListener('cart-drawer:open', () => {
  cartItem.init()
});

document.addEventListener('cart:items-rerendered', () => {
  cartItem.init();
});

var updateMobileHeaderSearchBar = () => {
  if(window.innerWidth <= 750 && document.body.classList.contains('new-builder-design')) {
    const header = document.querySelector('header');
    if (!header) return;
    if (window.scrollY > 0) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  }
}

window.addEventListener('scroll', () => {
  updateMobileHeaderSearchBar();
});